export default "__VITE_ASSET__Y1jXEgeG__"